// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {pluralize, capitalize, intensityColor, iconifyTask} from './filters'

Vue.config.productionTip = false

// Add global filters
Vue.filter('pluralize', pluralize)
Vue.filter('capitalize', capitalize)
Vue.filter('intensityColor', intensityColor)
Vue.filter('iconifyTask', iconifyTask)

console.log('Environment: ' + process.env.NODE_ENV)
console.log('Application version: ' + process.env.APP_VERSION)

Vue.prototype.$reloadApp = () => { location.replace('/') }
const eventBus = new Vue()
Vue.prototype.$events = eventBus

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js